import { render, staticRenderFns } from "./ChatTempMessage.vue?vue&type=template&id=8c4ab010&"
import script from "./ChatTempMessage.vue?vue&type=script&lang=js&"
export * from "./ChatTempMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports